import {axios} from "./config"
export class Vehicle extends axios{
axios;
constructor(){
    super();
    this.axios=this.axiosConfig();
}
async getAllData(){
           
    try{
    let result=await this.axios({
    method:"post",
    url:"vehicle/getAllData",
    
});
    return new Promise((res,rej)=>{
        res(result.data);
    })
    }catch(e){
        return new Promise((res,rej)=>{
            rej(e);
        })
      
    }
      }
      async Add(data){
           
        try{
        let result=await this.axios({
        method:"post",
        url:"vehicle/add",
        data
        
    });
        return new Promise((res,rej)=>{
            res(result.data);
        })
        }catch(e){
            return new Promise((res,rej)=>{
                rej(e);
            })
          
        }
          }
          async delete(data){
           
            try{
            let result=await this.axios({
            method:"post",
            url:"vehicle/delete",
            data
            
        });
            return new Promise((res,rej)=>{
                res(result.data);
            })
            }catch(e){
                return new Promise((res,rej)=>{
                    rej(e);
                })
              
            }
              }
}
